import { render, staticRenderFns } from "./TitlesCreate.vue?vue&type=template&id=f0c772fc"
import script from "./TitlesCreate.vue?vue&type=script&lang=js"
export * from "./TitlesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports